import { __decorate } from "tslib";
import { Service } from 'typedi';
import { HttpStatusCodes } from '../models';
var PopulateUserIdMiddleware = /** @class */ (function () {
    function PopulateUserIdMiddleware() {
    }
    PopulateUserIdMiddleware.prototype.populateUserId = function (req, res, next) {
        var _a, _b, _c, _d, _e;
        var userId = ((_c = (_b = (_a = req === null || req === void 0 ? void 0 : req.requestContext) === null || _a === void 0 ? void 0 : _a.authorizer) === null || _b === void 0 ? void 0 : _b.claims) === null || _c === void 0 ? void 0 : _c.sub) || ((_e = (_d = req === null || req === void 0 ? void 0 : req.requestContext) === null || _d === void 0 ? void 0 : _d.authorizer) === null || _e === void 0 ? void 0 : _e.principalId) || '';
        if (!userId || userId.length < 10) {
            res.error(HttpStatusCodes.Unauthorized, 'User Not Found');
        }
        req.userId = userId;
        next();
    };
    PopulateUserIdMiddleware = __decorate([
        Service()
    ], PopulateUserIdMiddleware);
    return PopulateUserIdMiddleware;
}());
export { PopulateUserIdMiddleware };
